import { render, staticRenderFns } from "./MovieSwiper.vue?vue&type=template&id=24bb729c&scoped=true&"
import script from "./MovieSwiper.vue?vue&type=script&lang=js&"
export * from "./MovieSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MovieSwiper.vue?vue&type=style&index=0&id=24bb729c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb729c",
  null
  
)

export default component.exports